import { /* Message, */ElNotification } from 'element-plus'

let msgIns = null
function errMsg (msg) {
    if (msgIns) {
        msgIns.close()
    }
    msgIns = ElNotification({
        dangerouslyUseHTMLString: true,
        title: '提示',
        message: msg,
        duration: 5000,
        offset: 0,
        type: 'error',
        customClass: 'el-notification--error'
    })
}

function okMsg (msg) {
    if (msgIns) {
        msgIns.close()
    }
    msgIns = ElNotification({
        dangerouslyUseHTMLString: true,
        title: '提示',
        message: msg,
        duration: 3000,
        offset: 0,
        type: 'success',
        customClass: 'el-notification--success'
    })
}

export default {
    errMsg,
    okMsg
}
